if (!customElements.get('clc-chair-amount')) {
  customElements.define('clc-chair-amount', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.info = this.closest('product-info');
      this.native = this.info?.querySelector('input[name="quantity"]'); this.form = this.native?.form;
      if (!this.native || !this.form || !window.CLCBulkPricing) return;
      this.pricing = window.CLCBulkPricing;
      try { this.context = this.pricing.contextFrom(this); this.prices = JSON.parse(this.querySelector('[data-chair-prices]').textContent); } catch { return; }
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'AUD', currencyDisplay:'narrowSymbol'});
      this.input = this.info.querySelector('.clc-chair-input'); this.customBox = this.info.querySelector('.clc-chair-custom');
      if (!this.input || !this.customBox) return;
      this.error = this.querySelector('.clc-chair-error'); this.refreshError = this.querySelector('[data-cart-refresh-error]');
      this.tiles = [...this.querySelectorAll('[data-pieces]')];
      const initialQuantity = Number(this.dataset.initialQuantity) || 12;
      this.quantityStateKey = this.info.dataset.productId ? `clc:quantity:${this.info.dataset.productId}` : null;
      let remembered;
      try { if (this.quantityStateKey) remembered = JSON.parse(sessionStorage.getItem(this.quantityStateKey)); } catch {}
      const nativeQuantity = Number(this.native.value);
      // Dawn initializes this field to its minimum; that bootstrap is not a shopper choice.
      const nativeRestored = this.native.value !== this.native.defaultValue && nativeQuantity !== this.minimum() && this.validQuantity(nativeQuantity);
      const rememberedValid = remembered && this.validQuantity(remembered.quantity);
      const quantity = nativeRestored ? nativeQuantity : rememberedValid ? remembered.quantity : initialQuantity;
      this.count = this.validQuantity(quantity) ? quantity : this.minimum();
      this.customMode = rememberedValid && this.count === remembered.quantity ? remembered.custom === true : !this.isPresetQuantity(this.count);
      this.hasQuantityChoice = nativeRestored || Boolean(rememberedValid);
      const customQuantity = remembered && this.validQuantity(remembered.customQuantity) ? remembered.customQuantity : this.minimum();
      this.input.value = String(this.customMode ? this.count : customQuantity); this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.addEventListener('click', event => {
        const tile = event.target.closest('[data-pieces]');
        if (tile && !tile.disabled) {
          this.choose(tile);
          if (tile.dataset.pieces === 'custom') {
            // Keep focus in the tap handler so mobile browsers can open their numeric keyboard.
            this.input.focus({preventScroll: true});
            this.input.select();
          }
        }
        if (event.target.closest('[data-refresh-cart]')) this.refreshCart();
      }, options);
      this.customBox.querySelectorAll('[data-adjust]').forEach(button => button.addEventListener('click', () => {
        const current = Number(this.input.value) || this.minimum(), direction = Number(button.dataset.adjust), offset = (current - this.minimum()) / this.step();
        const next = this.minimum() + (direction > 0 ? Math.floor(offset) + 1 : Math.ceil(offset) - 1) * this.step();
        this.input.value = String(Math.min(this.maximum(), Math.max(this.minimum(), next))); this.choose(this.tiles[0]);
      }, options));
      this.input.addEventListener('input', () => this.choose(this.tiles[0]), options);
      const revealCustomInput = () => this.scheduleCustomInputReveal();
      this.input.addEventListener('focus', () => {
        this.customRevealAllowed = true;
        this.scheduleCustomInputReveal(350);
      }, options);
      this.input.addEventListener('blur', () => this.cancelCustomInputReveal(), options);
      document.addEventListener('touchstart', event => {
        this.quantityTouchStart = document.activeElement === this.input && event.touches.length === 1 && event.target !== this.input
          ? {x: event.touches[0].clientX, y: event.touches[0].clientY} : null;
      }, {...options, passive: true});
      document.addEventListener('touchmove', event => {
        if (!this.quantityTouchStart || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - this.quantityTouchStart.x;
        const dy = event.touches[0].clientY - this.quantityTouchStart.y;
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) this.dismissCustomInput();
      }, {...options, passive: true});
      const clearTouch = () => { this.quantityTouchStart = null; };
      document.addEventListener('touchend', clearTouch, {...options, passive: true});
      document.addEventListener('touchcancel', clearTouch, {...options, passive: true});
      document.addEventListener('wheel', event => {
        if (event.deltaY && document.activeElement === this.input) this.dismissCustomInput();
      }, {...options, passive: true});
      document.addEventListener('keydown', event => {
        if (document.activeElement === this.input && ['Escape', 'PageUp', 'PageDown'].includes(event.key)) this.dismissCustomInput();
      }, options);
      window.visualViewport?.addEventListener('resize', revealCustomInput, options);
      window.visualViewport?.addEventListener('scroll', () => {
        if (this.revealTimer) this.scheduleCustomInputReveal();
      }, options);
      window.addEventListener('resize', revealCustomInput, options);
      this.addEventListener('keydown', event => {
        const tile = event.target.closest('[data-pieces]');
        if (!tile || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        const available = this.tiles.filter(item => !item.disabled), current = available.indexOf(tile);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? available.length - 1 : (current + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1) + available.length) % available.length;
        event.preventDefault(); this.choose(available[index]); available[index].focus();
      }, options);
      this.form.addEventListener('submit', event => { if (this.apply()) return; event.preventDefault(); event.stopImmediatePropagation(); this.input.focus(); }, {...options, capture:true});
      this.form.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.apply();
      }, options);
      this.native.addEventListener('input', () => this.adoptNativeQuantity(), options);
      this.native.addEventListener('change', () => this.adoptNativeQuantity(), options);
      if (typeof subscribe === 'function') {
        this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
        this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.apply());
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => { if (data.sectionId === this.dataset.section) this.apply(); });
      }
      document.addEventListener('clc:pricing-context', event => { this.context = event.detail; this.contextStale = false; this.refreshError.hidden = true; this.apply(); }, options);
      window.addEventListener('pageshow', event => { this.adoptNativeQuantity(true); if (event.persisted) this.refreshCart(); }, options);
      this.info.classList.add('clc-chair-enhanced'); this.hidden = false; this.apply();
    }
    minimum() { return Math.max(1, Number(this.native.min) || 1); }
    isPresetQuantity(quantity) { return this.tiles.some(tile => tile.dataset.pieces !== 'custom' && Number(tile.dataset.pieces) === quantity); }
    adoptNativeQuantity(restoring = false) {
      const quantity = Number(this.native.value), current = this.customMode ? Number(this.input.value) : this.count;
      if (restoring && this.hasQuantityChoice && (this.native.value === this.native.defaultValue || quantity === this.minimum()) && quantity !== current) {
        this.apply();
        return;
      }
      if (!this.validQuantity(quantity) || quantity === current) return;
      this.count = quantity;
      this.customMode = !this.isPresetQuantity(quantity);
      if (this.customMode) this.input.value = String(quantity);
      this.hasQuantityChoice = true;
      this.apply();
    }
    rememberQuantity(quantity) {
      if (!this.quantityStateKey || !this.hasQuantityChoice) return;
      try {
        sessionStorage.setItem(this.quantityStateKey, JSON.stringify({quantity, custom: this.customMode, customQuantity: Number(this.input.value)}));
      } catch {}
    }
    cancelCustomInputReveal() {
      clearTimeout(this.revealTimer);
      cancelAnimationFrame(this.revealFrame);
      cancelAnimationFrame(this.quantityScrollFrame);
      this.revealTimer = null;
      this.revealFrame = null;
      this.quantityScrollFrame = null;
      this.customRevealAllowed = false;
      this.quantityTouchStart = null;
    }
    dismissCustomInput() {
      this.cancelCustomInputReveal();
      if (document.activeElement === this.input) this.input.blur();
    }
    scheduleCustomInputReveal(delay = 140) {
      clearTimeout(this.revealTimer);
      this.revealTimer = null;
      if (!this.customRevealAllowed || !this.isConnected || this.customBox.hidden || document.activeElement !== this.input) return;
      // Let keyboard resizing and native viewport panning finish before one correction.
      this.revealTimer = setTimeout(() => {
        this.revealTimer = null;
        this.revealFrame = requestAnimationFrame(() => { this.revealFrame = null; this.revealCustomInput(); });
      }, delay);
    }
    revealCustomInput() {
      if (!this.customRevealAllowed || !this.isConnected || this.customBox.hidden || document.activeElement !== this.input) return;
      this.customRevealAllowed = false;
      // The keyboard can shrink the visual viewport without resizing the page layout.
      const viewport = window.visualViewport;
      const top = (viewport?.offsetTop || 0) + 24;
      const bottom = (viewport?.offsetTop || 0) + (viewport?.height || window.innerHeight) - 56;
      const rect = this.customBox.getBoundingClientRect();
      // Move only the clipped distance, preserving the context above the quantity row.
      const distance = rect.bottom > bottom ? rect.bottom - bottom : rect.top < top ? rect.top - top : 0;
      if (Math.abs(distance) < 1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollBy({top: distance, behavior: 'instant'});
        return;
      }
      // Own the short animation so a swipe can cancel it before the next frame.
      const startY = window.scrollY, startTime = performance.now();
      const step = now => {
        if (!this.isConnected || this.customBox.hidden || document.activeElement !== this.input) return;
        const progress = Math.min(1, (now - startTime) / 240);
        window.scrollTo({top: startY + distance * (1 - Math.pow(1 - progress, 3)), left: window.scrollX, behavior: 'instant'});
        this.quantityScrollFrame = progress < 1 ? requestAnimationFrame(step) : null;
      };
      this.quantityScrollFrame = requestAnimationFrame(step);
    }
    maximum() { return this.native.hasAttribute('max') && this.native.max !== '' ? Number(this.native.max) : Infinity; }
    step() { return Math.max(1, Number(this.native.step) || 1); }
    validQuantity(quantity) { return Number.isSafeInteger(quantity) && quantity >= this.minimum() && quantity <= this.maximum() && (quantity - this.minimum()) % this.step() === 0; }
    choose(tile) { if (tile) { this.hasQuantityChoice = true; this.customMode = tile.dataset.pieces === 'custom'; if (!this.customMode) { this.dismissCustomInput(); this.count = Number(tile.dataset.pieces); } this.apply(); } }
    async refreshCart() {
      this.refreshAbort?.abort(); this.refreshAbort = new AbortController();
      try { await this.pricing.refresh(this.refreshAbort.signal); }
      catch (error) { if (error.name !== 'AbortError') { this.contextStale = true; this.refreshError.hidden = false; this.apply(); } }
    }
    apply() {
      if (!this.input) return false;
      if (!this.customMode && !this.validQuantity(this.count)) { this.customMode = true; this.input.value = String(this.minimum()); }
      const quantity = this.customMode ? Number(this.input.value) : this.count, valid = this.validQuantity(quantity);
      this.input.min = String(this.minimum()); this.input.step = String(this.step());
      if (Number.isFinite(this.maximum())) this.input.max = String(this.maximum()); else this.input.removeAttribute('max');
      this.input.setAttribute('aria-invalid', String(!valid)); this.error.hidden = valid;
      this.tiles[0].querySelector('.clc-chair-label').textContent = `${Number(this.input.value) > 0 ? this.input.value : this.minimum()}x`;
      this.tiles.forEach(tile => {
        tile.disabled = tile.dataset.pieces !== 'custom' && !this.validQuantity(Number(tile.dataset.pieces));
        const selected = this.customMode ? tile.dataset.pieces === 'custom' : Number(tile.dataset.pieces) === this.count;
        tile.setAttribute('aria-checked', String(selected)); tile.tabIndex = selected ? 0 : -1;
      });
      this.customBox.hidden = !this.customMode;
      this.info.classList.toggle('clc-chair-custom-active', this.customMode);
      this.customBox.querySelector('[data-adjust="-1"]').disabled = Number(this.input.value) <= this.minimum();
      this.customBox.querySelector('[data-adjust="1"]').disabled = Number(this.input.value) >= this.maximum();
      this.native.value = valid ? String(quantity) : '';
      if (valid) this.rememberQuantity(quantity);
      const values = this.prices[this.form.querySelector('input[name="id"]')?.value];
      const totalNode = this.querySelector('[data-summary-total]'), savingNode = this.info.querySelector('[data-summary-saving]'), coverage = this.querySelector('[data-summary-coverage]'), note = this.querySelector('[data-price-note]');
      if (!values || !valid) {
        if (values && valid) this.renderQuantityPrice(values, 0, quantity);
        totalNode.textContent = this.contextStale && this.refreshError.hidden ? 'Updating…' : '—'; savingNode.hidden = true;
        coverage.hidden = true; coverage.textContent = '';
        note.textContent = ''; return valid;
      }
      // PDP prices describe this selection; mixed-cart savings are resolved in cart/checkout.
      const quote = this.pricing.quote(values.price, quantity, 0, values.pieces_per_unit), pack = values.pieces_per_unit > 1;
      this.tiles.forEach(tile => {
        const units = tile.dataset.pieces === 'custom' ? Number(this.input.value) || this.minimum() : Number(tile.dataset.pieces), tileQuote = this.pricing.quote(values.price, units, 0, values.pieces_per_unit);
        const chairCoverage = this.coverageFor(tileQuote.pieces);
        tile.setAttribute('aria-label', `${tile.dataset.pieces === 'custom' ? 'Custom quantity: ' : ''}${units} ${pack ? 'packs' : units === 1 ? 'piece' : 'pieces'}, ${chairCoverage}, estimated ${this.money.format(tileQuote.total / 100)}, ${tileQuote.rate}% bulk savings`);
      });
      coverage.hidden = false; coverage.textContent = this.coverageFor(quote.pieces);
      const savingRate = quote.rate || (values.compare_at > values.price ? Math.round((values.compare_at - values.price) * 100 / values.compare_at) : 0);
      totalNode.textContent = this.money.format(quote.total / 100); savingNode.textContent = `Save ${savingRate}%`; savingNode.hidden = savingRate === 0;
      this.renderQuantityPrice(values, quote.rate, quantity);
      note.textContent = pack ? `${values.pieces_per_unit} pieces per pack.` : '';
      if ((this.context.discount_codes || []).some(code => code.applicable)) note.textContent += ' Any eligible code is compared in your cart; the best offer applies.';
      return valid;
    }
    coverageFor(pieces) { return pieces % 4 === 0 ? `${pieces / 4}x ${pieces === 4 ? 'chair' : 'chairs'}` : `${pieces} ${pieces === 1 ? 'piece' : 'pieces'}`; }
    renderQuantityPrice(values, rate, quantity) {
      const price = this.info.querySelector('.product__value-price');
      if (!price?.querySelector) return;
      const gross = values.price * quantity;
      const discounted = gross - Math.round(gross * rate / 100);
      const reference = (rate > 0 ? values.price : Math.max(values.price, values.compare_at || 0)) * quantity;
      const sale = price.querySelector('.price-item--sale');
      const regular = price.querySelector('.price__regular .price-item--regular');
      const compare = price.querySelector('.price__compare-at .price-item--regular');
      if (sale) sale.textContent = this.money.format(discounted / 100);
      if (regular) regular.textContent = this.money.format(gross / 100);
      if (compare) compare.textContent = this.money.format(reference / 100);
      price.classList.toggle('price--on-sale', reference > discounted);
      price.querySelectorAll('.price__sale-pill').forEach(pill => { pill.hidden = rate > 0; });
    }
    disconnectedCallback() { this.cancelCustomInputReveal(); this.abort?.abort(); this.abort = null; this.refreshAbort?.abort(); this.cartUnsubscribe?.(); this.quantityUnsubscribe?.(); this.variantUnsubscribe?.(); }
  });
}
